import * as React from 'react';
import { IRootState } from 'store/modules';
import { connect } from 'react-redux';
import { RedeemCodeComponent } from 'components/presentational/controls'
import { Models } from 'fluent-forever-shared-types';
import * as App from 'application';
import * as Store from 'store';


export interface IRedeemCodeOwnProps {
    onCodeRedeemed(result);
}

export interface IRedeemCodeProps {
    fetchCodeInfo(code: string): Promise<void | Models.ICouponCodeInfo>;
    redeemCode(code: string): Promise<any>;
    clearWarnings();
}

interface IRedeemCodeState {
    code: string;
    codeInfo: string;
    isInvalid: boolean;
    isLoading: boolean;
}

const mapStateToProps = (state: IRootState) => ({

});

const mapDispatchToProps = (dispatch) => ({
    fetchCodeInfo: (code) => App.CouponCode.fetchCouponCodeInfo(code, dispatch),
    redeemCode: (code) => App.CouponCode.redeemCouponCode(code, dispatch),
    clearWarnings: () => dispatch(Store.Notifications.clearNotifications()),
})

const defaultState: IRedeemCodeState = { code: '', codeInfo: null, isInvalid: false, isLoading: false }

//** Container/UI logic for Redeeming Code */
export class RedeemCodeContainer extends React.Component<IRedeemCodeProps & IRedeemCodeOwnProps, IRedeemCodeState> {
    constructor(props) {
        super(props);
        this.state = defaultState;
    }

    onCodeValueChanged = (code: string) => {
        this.setState({ code });
        this.setInvalid(false);
        this.props.clearWarnings();
    }

    onCodeInfoChanged = (codeInfo: string) => {
        this.setState({ codeInfo })
    }

    setLoading = (isLoading: boolean) => {
        this.setState({ isLoading });
    }

    onGetCodeInfo = () => {
        const { code } = this.state;
        if (this.checkIsValid(code)) {
            this.props.fetchCodeInfo(code)
                .then((info) => {
                    if (info) {
                        this.onCodeInfoChanged(info.details);
                    }
                })
                .catch(this.onReset)
        }
    }

    onReset = () => {
        this.setState(defaultState);
    }

    setInvalid = (isInvalid = false) => {
        this.setState({ isInvalid });
    }

    checkIsValid = (code) => {
        const result = code && code.replace('_', '').length >= "XXXX-XXXX-XXXX".length;
        if (!result) {
            this.setInvalid(true);
        }
        return result;
    }

    onRedeemCode = () => {
        const { code } = this.state;
        if (this.checkIsValid(code)) {
            this.setLoading(true);
            this.props.redeemCode(code)
                .then((result) => {
                    this.props.onCodeRedeemed(result);
                    this.onReset();
                })
                .catch(this.onReset);
        }
    }

    render() {
        const { code, codeInfo, isInvalid, isLoading } = this.state;
        return <RedeemCodeComponent
            code={code}
            codeInfo={codeInfo}
            isInvalid={isInvalid}
            onCodeValueChanged={this.onCodeValueChanged}
            onHideCodeInfo={this.onReset}
            onGetCodeInfo={this.onGetCodeInfo}
            onSubmitCode={this.onRedeemCode}
            isLoading={isLoading}
        />

    }
}

export const RedeemCode = connect(mapStateToProps, mapDispatchToProps)(RedeemCodeContainer);


// WEBPACK FOOTER //
// ./src/components/containers/RedeemCode/index.tsx